export default __webpack_public_path__ + "static/media/navTabSelection.ab68b971.png";